import { render, staticRenderFns } from "./EcoScoreArvView.vue?vue&type=template&id=19e3d050&scoped=true&"
import script from "./EcoScoreArvView.vue?vue&type=script&lang=js&"
export * from "./EcoScoreArvView.vue?vue&type=script&lang=js&"
import style0 from "./EcoScoreArvView.vue?vue&type=style&index=0&id=19e3d050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3d050",
  null
  
)

/* custom blocks */
import block0 from "./EcoScoreArvView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports